/* @flow */

import type { NETGEM_API_DMS_REQUEST_RESPONSE_ASSOCIATED_DEVICE } from '../types/RequestResponseAssociatedDevice';

import { HttpMethod } from '../../v8/types/HttpMethod';
import createDmsCommonRequestHeader from '../helpers/CreateCommonRequestHeader';
import sendDmsPromisedXMLHttpRequest from '../helpers/PromisedXMLHttpRequest';

const dmsAssociatedDeviceRequest: (baseAuthDeviceUrl: string, authenticationToken: string | null, signal?: AbortSignal) => Promise<NETGEM_API_DMS_REQUEST_RESPONSE_ASSOCIATED_DEVICE> = (
  baseAuthDeviceUrl,
  authenticationToken,
  signal,
) => sendDmsPromisedXMLHttpRequest(`${baseAuthDeviceUrl}list`, HttpMethod.GET, createDmsCommonRequestHeader(authenticationToken), null, null, false, signal).promise;

export default dmsAssociatedDeviceRequest;
